import React from 'react';

const YourOrder = () => {
    return (
        <div className="step-content">
            YourOrder
        </div>
    );
}

export default YourOrder;